import React from "react";
import { useTranslation } from "react-i18next";
import type { ActivityFormPayload } from "@/services/api/activity/types";

interface ActivityFormDateStepProps {
  payload: ActivityFormPayload;
  onChange: <K extends keyof ActivityFormPayload>(key: K, value: ActivityFormPayload[K]) => void;
}

const ActivityFormDateStep: React.FC<ActivityFormDateStepProps> = ({ payload, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <section className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
        <h2 className="text-sm font-bold text-gray-900">{t("Date & Time*")}</h2>
        <div className="mt-3 grid gap-4 sm:grid-cols-2">
          <div>
            <label className="text-sm font-bold text-gray-900">{t("Date")}</label>
            <input
              type="date"
              value={payload.date}
              onChange={(e) => onChange("date", e.target.value)}
              className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm text-gray-900 outline-none transition focus:border-[#ffa217] focus:ring-2 focus:ring-[#fff3e0]"
            />
          </div>
          <div>
            <label className="text-sm font-bold text-gray-900">{t("Time")}</label>
            <input
              type="time"
              value={payload.time}
              onChange={(e) => onChange("time", e.target.value)}
              className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm text-gray-900 outline-none transition focus:border-[#ffa217] focus:ring-2 focus:ring-[#fff3e0]"
            />
          </div>
        </div>
      </section>

      <section className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
        <h2 className="text-sm font-bold text-gray-900">{t("Meeting Date & Time")}</h2>
        <div className="mt-3 grid gap-4 sm:grid-cols-2">
          <div>
            <label className="text-sm font-bold text-gray-900">{t("Meeting Date")}</label>
            <input
              type="date"
              value={payload.meetingDate}
              onChange={(e) => onChange("meetingDate", e.target.value)}
              className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm text-gray-900 outline-none transition focus:border-[#ffa217] focus:ring-2 focus:ring-[#fff3e0]"
            />
          </div>
          <div>
            <label className="text-sm font-bold text-gray-900">{t("Meeting Time")}</label>
            <input
              type="time"
              value={payload.meetingTime}
              onChange={(e) => onChange("meetingTime", e.target.value)}
              className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm text-gray-900 outline-none transition focus:border-[#ffa217] focus:ring-2 focus:ring-[#fff3e0]"
            />
          </div>
        </div>
      </section>

      <section className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm">
        <h2 className="text-sm font-bold text-gray-900">{t("Application Deadline")}</h2>
        <div className="mt-3 grid gap-4 sm:grid-cols-2">
          <div>
            <label className="text-sm font-bold text-gray-900">{t("Deadline Date")}</label>
            <input
              type="date"
              value={payload.deadlineDate}
              onChange={(e) => onChange("deadlineDate", e.target.value)}
              className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm text-gray-900 outline-none transition focus:border-[#ffa217] focus:ring-2 focus:ring-[#fff3e0]"
            />
          </div>
          <div>
            <label className="text-sm font-bold text-gray-900">{t("Deadline Time")}</label>
            <input
              type="time"
              value={payload.deadlineTime}
              onChange={(e) => onChange("deadlineTime", e.target.value)}
              className="mt-2 w-full rounded-xl border border-gray-200 px-3 py-2 text-sm text-gray-900 outline-none transition focus:border-[#ffa217] focus:ring-2 focus:ring-[#fff3e0]"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ActivityFormDateStep;
